import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import CidrDetails from './CidrDetails';
import { useUser } from '../../../contexts/UserContext';
import {
  getSubdomain,
  isAssistantInstance,
  isGPSInstance,
  isSolrInstance,
} from '../../../utils/utils';
import CopyableText from '../../elements/copyable-text/CopyableText';
import Text from '../../elements/text/Text';
import Metadata from '../metadata/Metadata';

const InstanceInfo = ({ instance }) => {
  const { projectId } = useParams();
  const { user } = useUser();
  const { t } = useTranslation();

  const { clusterType } = instance;

  const hasSubdomain =
    isSolrInstance(clusterType) ||
    isGPSInstance(clusterType) ||
    isAssistantInstance(clusterType);

  return (
    <Box>
      <Text subtitle>{t('instanceInfo', { ns: 'instance' })}</Text>
      <CopyableText
        id="solr-id"
        label={t('instanceId', { ns: 'instance' })}
        text={instance.id}
      />
      {hasSubdomain && (
        <CidrDetails
          instance={instance}
          isAdmin={user?.isAdmin?.(projectId)}
          solrUrl={getSubdomain(instance)}
        />
      )}

      {isSolrInstance(clusterType) && (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Text caption color="textSecondary">
            Solr Type: {instance.type}
          </Text>
          <Text caption color="textSecondary">
            {t('solrVersion', { ns: 'fields' })}: {instance.solrVersion}
          </Text>
        </Box>
      )}

      <Box sx={{ mt: 2 }}>
        <Metadata creator={instance.author} createDate={instance.createDate} />
      </Box>
    </Box>
  );
};

InstanceInfo.propTypes = {
  instance: PropTypes.object.isRequired,
};

export default InstanceInfo;
